import {signIn, forgotPassword, getSelf} from "../../services/apollo/auth";
import {disconnectSocket} from "../../services/socket/socket";

export default {
  namespaced: true,

  actions: {
    signIn({commit}, {email, password, gRecaptcha}) {
      return signIn(email, password, gRecaptcha)
        .then(({signIn}) => {
          commit('setUser', signIn)
        })
    },
    logout({commit}) {
      disconnectSocket()
      commit('removeUser')
    },
    forgotPassword({commit}, {email, gRecaptcha}) {
      return forgotPassword(email, gRecaptcha)
    },
    apiSignIn({commit}, token) {
      commit('setToken', token);
      return getSelf()
        .then(user => {
          commit('setUser', {token, user})
        })
        .catch(err => {
          commit('setToken', null);
          return Promise.reject(err)
        })
    }
  },

  mutations: {
    setUser(state, {user, token}) {
      state.self = user;
      state.token = token;
    },
    setToken(state, token) {
      state.token = token;
    },
    removeUser(state) {
      state.self = null;
      state.token = null;
    }
  },
  state: {
    self: null,
    token: null
  }
}
